.secondary-nav {
  border-bottom: 1px solid #2222221F;
  height: 46px;
  overflow: hidden;

  ul {
    list-style: none;
    padding: 0 20px;
    max-width: 1290px;
    margin: 0 auto;
    overflow-y: hidden;
    white-space: nowrap;

    li {
      display: inline-block;
      min-height: 46px;
      text-align: center;
      margin: 0 12px;

      a {
        font-size: 14px;
        font-weight: 500;
        color: #222222A3;
        padding: 16px 0 15px 0;
        display: inline-block;
        text-decoration: none;
        border-bottom: 1px solid transparent;
        min-height: 15px;
      }

      .link-active {
        border-bottom: 1px solid #222;
        display: block;
        color: #222;
        font-weight: 600;
      }

      &:first-child a {
        margin-left: 0;
      }
    }
  }
}

@media (max-width: 995px) {
  .secondary-nav {

    ul {
      overflow-y: scroll;
    }
  }
}
